import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from 'react';
import { Button, Popconfirm, Space, Table, Tag } from 'antd';
import type { ColumnsType, } from 'antd/es/table';
import { DeleteOutlined, EditOutlined, KeyOutlined } from '@ant-design/icons';
import { getFullDateTime } from "../../helper";
import { API_URL } from "../../constants";
import { useAuth } from "react-oidc-context";
import { Configuration, IdentityUserDto, ItemDto, RoleApi } from "../../api/najd";

interface DataGridProps {
    onClickRowEdit: (rowData: any) => void;
    onClickRowEditPerm: (rowData: any) => void;
    refreshTrigger: boolean;
    setRefreshTrigger: React.Dispatch<React.SetStateAction<boolean>>;
}

const RolesTable: React.FC<DataGridProps> = ({ onClickRowEdit,onClickRowEditPerm, refreshTrigger, setRefreshTrigger }) => {
    const auth = useAuth();
    const { t } = useTranslation();
    const [userData, setUserData] = useState<IdentityUserDto[]>([]);
    const [loading, setLoading] = useState(false);

    const token = auth.user?.access_token;
    const configuration = new Configuration({
        basePath: API_URL,
        accessToken: token,
        baseOptions: {
            headers: { Authorization: 'Bearer ' + token },
        }
    });
    const roleApi = new RoleApi(configuration);

    const columns: ColumnsType<IdentityUserDto> = [
        { title: t('Role Name'), dataIndex: 'name', key: 'name', },
        {
            title: t('Default'),
            dataIndex: 'isDefault',
            key: 'isDefault',
            render: (active: boolean) => <span>{active ? 'Yes' : 'No'}</span>,
        },
        {
            title: t('Public'),
            dataIndex: 'isPublic',
            key: 'isPublic',
            render: (active: boolean) => <span>{active ? 'Yes' : 'No'}</span>,
        },
        {
            title: t('Action'),
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <Button type="primary" icon={<EditOutlined />} onClick={() => { handleRowClick(record) }} />
                    <Button type="primary" icon={<KeyOutlined />} onClick={() => { handleRowClickPerm(record) }} />
                    <Popconfirm
                        title={t("Are you sure you want to delete this item?")}
                        onConfirm={() => handleDelete(record.id)}
                        okText={t("Yes")}
                        cancelText={t("No")}
                    >
                        <Button type="default" icon={<DeleteOutlined />} danger
                            key={'con-btn-' + record.id} />
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    // Use the onClickRowEdit function as needed
    const handleRowClick = (rowData: any) => {
        onClickRowEdit(rowData);
    };
    // Use the onClickRowEdit function as needed
    const handleRowClickPerm = (rowData: any) => {
        onClickRowEditPerm(rowData);
    };

    const handleDelete = (id: any) => {
        console.log('Clicked cancel button');
        roleApi.roleDelete(id)
            .then(response => {
                // Handle the API response            
                console.log(response.data);
                handleRefresh();
            })
            .catch(error => {
                // Handle the API error
                console.error(error);
            });
    };

    useEffect(() => {
        setLoading(true);
        const fetchUserData = async () => {
            try {
                const response = await roleApi.roleGetList();
                setUserData(response.data.items ?? []);
                setLoading(false);
            } catch (error) {
                console.error(error);
            }
        };
        fetchUserData();
    }, [refreshTrigger]); // Add refreshTrigger as a dependency

    const handleRefresh = () => {
        setRefreshTrigger((prevState) => !prevState); // Toggle the refresh trigger
    };

    return (<>
        {/* <button onClick={handleRefresh}>Refresh Data</button> */}
        <Table<ItemDto>
            rowKey={(record) => record.id ?? ''}
            dataSource={userData}
            columns={columns}
            loading={loading}
        />
    </>
    );
};

export default RolesTable;